import * as React from "react"
import i18n from "../../../i18n/i18n"

interface ICitizenInfoComponentProps {
    firstName: string,
    lastName: string,
    civilRegistrationIdentifier: string,
}

export default class CitizenInfoComponent extends React.Component<ICitizenInfoComponentProps> {
    public render(): JSX.Element {
        const {
            firstName,
            lastName,
            civilRegistrationIdentifier
        } = this.props

        return (
            <table>
                <tbody>
                    <tr>
                        <td>{i18n.t("TEXT_NAME")}: </td>
                        <td data-ui-test="invoice-citizen-name"><b>{firstName}&nbsp;{lastName}</b></td>
                    </tr>
                    <tr>
                        <td>{i18n.t("TEXT_CIVIL_REGISTRATION_IDENTIFIER")}: </td>
                        <td data-ui-test="invoice-citizen-civilRegistrationIdentifier"><b>{civilRegistrationIdentifier}</b></td>
                    </tr>
                </tbody>
            </table>
        )
    }
}